import MainContainer from "../pages/MainContainer";

const pages = { MainContainer };
export default pages;
